/* ThreadMug – Growth Lab: product page AJAX Add to Cart + "Added to cart" panel.
   Loaded by sections/main-product-threadmug.liquid, which exposes window.TMPdpAtc.
   If this file fails to load, the product form simply submits natively. */
(function () {
  var api = window.TMPdpAtc;
  if (!api || !api.root || !api.productForm) return;
  var root = api.root;
  var atc = api.atc;
  var productForm = api.productForm;
  var variantInput = api.variantInput;
  var qtyInput = api.qtyInput;
  var validateMainForm = api.validateMainForm;
  var updateAtcLabel = api.updateAtcLabel;
  var showAtcError = api.showAtcError;
  var hideAtcError = api.hideAtcError;
  var formatMoney = api.formatMoney;

    /* ============================================================
     * Growth Lab: AJAX Add to Cart (stay on the product page)
     * ------------------------------------------------------------
     * Previously the form submitted natively to /cart/add, which makes
     * Shopify redirect to /cart. Now:
     *  - other submit listeners (Globo Product Options validation, the
     *    complementary-bundle handler above) run first; we listen on
     *    window, so we only act when nobody called preventDefault();
     *  - required fields are re-checked (validateMainForm);
     *  - the whole form (all properties[...] Globo fields, files,
     *    selling_plan) is posted to /cart/add.js as FormData;
     *  - on success the user stays here: the header cart count updates,
     *    an "Added to cart" panel opens and the button says
     *    "✓ Added — add another";
     *  - a Shopify error (e.g. sold out) is shown under the button;
     *  - anything unexpected falls back to the native submit, so the
     *    sale is never blocked.
     * ============================================================ */
    var tmMoneyFormat = api.moneyFormat || '';
    var tmCartUrl = api.cartUrl || '/cart';
    var tmRootUrl = api.rootUrl || '/';
    var tmNativeSubmitting = false;
    var tmAjaxBusy = false;

    function tmMoney(cents) {
      try {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, tmMoneyFormat);
        }
      } catch (e) {}
      var amount = (Number(cents) / 100).toFixed(2);
      var noDec = String(Math.round(Number(cents) / 100));
      var withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (typeof tmMoneyFormat === 'string' && /\{\{\s*amount/.test(tmMoneyFormat)) {
        return tmMoneyFormat
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
          .replace(/\{\{\s*amount\s*\}\}/, withComma);
      }
      return formatMoney(cents);
    }

    function tmEsc(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function tmNativeSubmit() {
      if (!productForm) return;
      tmNativeSubmitting = true;
      try {
        HTMLFormElement.prototype.submit.call(productForm);
      } catch (e) {
        tmNativeSubmitting = false;
      }
    }

    function tmCartError(msg) {
      var err = new Error(msg || 'Something went wrong adding this to your cart. Please try again.');
      err.tmCartError = true;
      return err;
    }

    function tmAjaxAdd() {
      if (!atc || !productForm) return false;
      if (tmAjaxBusy) return true;
      hideAtcError();
      if (!validateMainForm()) return true; /* error already shown; stay on page */
      var data = new FormData(productForm);
      if (!data.get('id')) data.set('id', variantInput.value);
      if (!data.get('quantity')) data.set('quantity', String(Number(qtyInput.value) || 1));
      tmAjaxBusy = true;
      var originalText = atc.textContent;
      atc.disabled = true;
      atc.textContent = 'Adding to cart…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: data,
      })
        .then(function (res) {
          return res
            .json()
            .catch(function () {
              return {};
            })
            .then(function (body) {
              if (!res.ok) throw tmCartError(body && (body.description || body.message));
              return body;
            });
        })
        .then(function (line) {
          tmAjaxBusy = false;
          atc.disabled = false;
          tmAfterAdd(line);
        })
        .catch(function (err) {
          tmAjaxBusy = false;
          atc.disabled = false;
          atc.textContent = originalText;
          updateAtcLabel();
          if (err && err.tmCartError) {
            showAtcError(err.message);
          } else {
            /* Network / unexpected failure: let the browser do it natively. */
            tmNativeSubmit();
          }
        });
      return true;
    }

    if (productForm) {
      /* Window-level, bubble phase: runs after every listener on the form
         and on document (Globo, bundle handler), so their decisions win. */
      window.addEventListener('submit', function (e) {
        if (e.target !== productForm) return;
        if (e.defaultPrevented || tmNativeSubmitting) return;
        try {
          if (tmAjaxAdd()) e.preventDefault();
        } catch (err) {
          /* fall through to the native submit */
        }
      });
      /* Apps sometimes finish with form.submit(), which skips submit
         events; route that through the same AJAX add. */
      try {
        productForm.submit = function () {
          if (tmNativeSubmitting) return HTMLFormElement.prototype.submit.call(productForm);
          var handled = false;
          try {
            handled = tmAjaxAdd();
          } catch (err) {
            handled = false;
          }
          if (!handled) tmNativeSubmit();
        };
      } catch (e) {}
      /* Any change to the personalization / options resets the
         "Added" state of the button. */
      var tmResetAdded = function (e) {
        if (!atc || !atc.classList.contains('is-added')) return;
        if (e && e.target && e.target.hasAttribute && e.target.hasAttribute('data-tm-card-checkbox')) return;
        updateAtcLabel();
      };
      productForm.addEventListener('input', tmResetAdded);
      productForm.addEventListener('change', tmResetAdded);
      productForm.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('[data-tm-option-value]')) tmResetAdded(e);
      });
    }

    /* ---------- After a successful add ---------- */
    function tmPairsTarget() {
      return (
        root.querySelector('[data-tm-complementary]:not([hidden])') ||
        document.querySelector('.tm-related')
      );
    }

    function tmScrollToPairs() {
      var target = tmPairsTarget();
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.pageYOffset - 110;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      target.classList.add('tm-pairs-highlight');
      setTimeout(function () {
        target.classList.remove('tm-pairs-highlight');
      }, 1800);
    }

    var tmGiftLink = root.querySelector('[data-tm-complete-gift]');
    if (tmGiftLink) {
      tmGiftLink.addEventListener('click', function (e) {
        e.preventDefault();
        tmScrollToPairs();
      });
    }

    function tmShowGiftLink() {
      if (!tmGiftLink) return;
      var target = tmPairsTarget();
      if (!target) return;
      /* 2026-10-02: longer label set here (Liquid still says "Complete the gift"); arrow span is kept. */
      var giftLabel = tmGiftLink.firstChild;
      if (giftLabel && giftLabel.nodeType === 3 && giftLabel.nodeValue.indexOf('pairs well') === -1) {
        giftLabel.nodeValue = 'Complete the gift — see what pairs well with it ';
      }
      var arrow = tmGiftLink.querySelector('[data-tm-complete-gift-arrow]');
      if (arrow && atc) {
        arrow.textContent =
          target.getBoundingClientRect().top < atc.getBoundingClientRect().top ? '↑' : '↓';
      }
      tmGiftLink.hidden = false;
    }

    function tmUpdateHeaderCart(cart) {
      if (!cart) return;
      var count = Number(cart.item_count) || 0;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
      });
      document.querySelectorAll('[data-cart-tt-price]').forEach(function (el) {
        el.textContent = tmMoney(cart.total_price);
      });
      var html = document.documentElement;
      html.className = html.className.replace(/\bt4s-cart-count-\d+\b/, 't4s-cart-count-' + count);
      var mini = document.getElementById('t4s-mini_cart');
      if (mini) mini.setAttribute('data-ccount', count);
      tmBumpCartIcons();
      try {
        if (window.TMDelivery && typeof window.TMDelivery.refresh === 'function') window.TMDelivery.refresh();
      } catch (e) {}
    }

    /* Header cart icon (desktop) + bottom toolbar cart icon (mobile):
       scale bounce, gold ring pulse and a count-badge pop (CSS in tm-pdp-atc.css;
       disabled under prefers-reduced-motion). */
    function tmBumpCartIcons() {
      document.querySelectorAll('.t4s-site-nav__cart, .t4s-toolbart-cart').forEach(function (el) {
        el.classList.remove('tm-cart-bump');
        void el.offsetWidth;
        el.classList.add('tm-cart-bump');
        setTimeout(function () {
          el.classList.remove('tm-cart-bump');
        }, 1300);
      });
    }

    var tmReduceMotion = false;
    try {
      tmReduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {}

    var TM_CHECK_SVG =
      '<svg class="tm-atc-check" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
    var tmAgainTimer = null;
    function tmAtcSuccess() {
      if (!atc) return;
      clearTimeout(tmAgainTimer);
      atc.classList.remove('is-added--again');
      atc.classList.add('is-added');
      atc.innerHTML = TM_CHECK_SVG + '<span>Added to cart</span>';
      atc.setAttribute('aria-label', 'Added to cart');
      tmAgainTimer = setTimeout(function () {
        if (!atc.classList.contains('is-added')) return; /* reset by an option / name change */
        atc.classList.add('is-added--again');
        atc.innerHTML = '<span>Add another</span>';
        atc.removeAttribute('aria-label');
      }, 1500);
    }

    function tmPanelPairsHtml() {
      var cards = root.querySelectorAll('[data-tm-complementary]:not([hidden]) [data-tm-recommendation-card]');
      var html = '';
      var shown = 0;
      for (var i = 0; i < cards.length && shown < 3; i++) {
        var c = cards[i];
        var url = c.getAttribute('data-product-url') || '#';
        var title = c.getAttribute('data-product-title') || '';
        var price = c.getAttribute('data-price');
        var img = c.querySelector('img');
        var available = c.getAttribute('data-available') === 'true';
        var personalize =
          c.getAttribute('data-requires-personalization') === 'true' ||
          c.getAttribute('data-name-field-required') === 'true';
        var vid = c.getAttribute('data-variant-id');
        /* Only cards that offer the one-click checkbox (single-variant,
           non-personalized) get "+ Add"; multi-variant items link to the PDP. */
        var quickAddable = !!c.querySelector('[data-tm-card-checkbox]');
        var action = personalize
          ? '<a class="tm-added__pair-btn" href="' + tmEsc(url) + '">Personalize</a>'
          : available && vid && quickAddable
          ? '<button type="button" class="tm-added__pair-btn" data-tm-added-quick="' + tmEsc(vid) + '">+ Add</button>'
          : '<a class="tm-added__pair-btn" href="' + tmEsc(url) + '">View</a>';
        html +=
          '<li class="tm-added__pair">' +
          '<a class="tm-added__pair-media" href="' + tmEsc(url) + '">' +
          (img ? '<img src="' + tmEsc(img.currentSrc || img.src) + '" alt="" loading="lazy" width="56" height="56">' : '') +
          '</a>' +
          '<a class="tm-added__pair-info" href="' + tmEsc(url) + '">' +
          '<span class="tm-added__pair-title">' + tmEsc(title) + '</span>' +
          (price ? '<span class="tm-added__pair-price">' + tmEsc(tmMoney(price)) + '</span>' : '') +
          '</a>' +
          action +
          '</li>';
        shown++;
      }
      if (!html) return '';
      return (
        '<div class="tm-added__pairs">' +
        '<p class="tm-added__pairs-heading">Pairs well with this</p>' +
        '<ul class="tm-added__pairs-list">' + html + '</ul>' +
        '</div>'
      );
    }

    /* 2026-10-02: show the store's short product name (the page H1), not the long SEO title. */
    function tmShortTitle(line) {
      var h1 = root.querySelector('.tm-pdp__title') || document.querySelector('.tm-pdp__title');
      var t = h1 ? String(h1.textContent || '').replace(/\s+/g, ' ').trim() : '';
      return t || line.product_title || line.title;
    }

    function tmLineHtml(line) {
      if (!line || !line.title) return '';
      var props = '';
      var p = line.properties || {};
      Object.keys(p).forEach(function (k) {
        var v = p[k];
        if (!k || k.charAt(0) === '_' || v == null || String(v).trim() === '') return;
        if (String(v).indexOf('/uploads/') !== -1 || /^https?:\/\//.test(String(v))) v = 'Uploaded file';
        props += '<li><span>' + tmEsc(k) + ':</span> ' + tmEsc(v) + '</li>';
      });
      var variant = line.variant_title && !/default title/i.test(line.variant_title) ? line.variant_title : '';
      var img = line.image ? String(line.image) : '';
      if (img) img = img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=300';
      return (
        '<div class="tm-added__item">' +
        (img ? '<img class="tm-added__item-img" src="' + tmEsc(img) + '" alt="" width="112" height="112">' : '') +
        '<div class="tm-added__item-info">' +
        '<p class="tm-added__item-title">' + tmEsc(tmShortTitle(line)) + '</p>' +
        (variant ? '<p class="tm-added__item-variant">' + tmEsc(variant) + '</p>' : '') +
        (props ? '<ul class="tm-added__item-props">' + props + '</ul>' : '') +
        '<p class="tm-added__item-price">' +
        (line.quantity > 1 ? tmEsc(line.quantity) + ' × ' : '') +
        tmEsc(tmMoney(line.final_price != null ? line.final_price : line.price)) +
        '</p>' +
        '</div>' +
        '</div>'
      );
    }

    var tmPanel = null;
    var tmPanelLastFocus = null;
    function tmClosePanel() {
      if (!tmPanel) return;
      tmPanel.classList.remove('is-open');
      tmPanel.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('tm-added-open');
      setTimeout(function () {
        if (tmPanel && !tmPanel.classList.contains('is-open')) tmPanel.hidden = true;
      }, 300);
      /* Point the shopper back at the cart icon (the panel covered it). */
      setTimeout(tmBumpCartIcons, 320);
      if (tmPanelLastFocus && tmPanelLastFocus.focus) {
        try {
          tmPanelLastFocus.focus({ preventScroll: true });
        } catch (e) {}
      }
    }

    function tmEnsurePanel() {
      if (tmPanel) return tmPanel;
      tmPanel = document.createElement('div');
      tmPanel.className = 'tm-added';
      tmPanel.hidden = true;
      tmPanel.setAttribute('aria-hidden', 'true');
      tmPanel.innerHTML =
        '<div class="tm-added__overlay" data-tm-added-close></div>' +
        '<div class="tm-added__panel" role="dialog" aria-modal="true" aria-labelledby="tm-added-title" tabindex="-1">' +
        '<span class="tm-added__handle" aria-hidden="true"></span>' +
        '<div class="tm-added__head">' +
        '<p class="tm-added__title" id="tm-added-title">' +
        '<span class="tm-added__title-icon" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>' +
        'Added to your cart</p>' +
        '<button type="button" class="tm-added__close" data-tm-added-close aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="tm-added__body" data-tm-added-body></div>' +
        '<div class="tm-added__foot">' +
        '<p class="tm-added__subtotal"><span data-tm-added-count>Cart subtotal</span><strong data-tm-added-subtotal></strong></p>' +
        '<div class="tm-added__btns">' +
        '<a class="tm-added__btn tm-added__btn--solid" href="' + tmEsc(tmRootUrl.replace(/\/$/, '') + '/checkout') + '">Checkout</a>' +
        '<a class="tm-added__btn tm-added__btn--ghost" href="' + tmEsc(tmCartUrl) + '">View cart</a>' +
        '</div>' +
        '<button type="button" class="tm-added__keep" data-tm-added-close>Keep shopping</button>' +
        '</div>' +
        '</div>';
      document.body.appendChild(tmPanel);
      tmPanel.addEventListener('click', function (e) {
        var closeEl = e.target.closest('[data-tm-added-close]');
        if (closeEl) {
          tmClosePanel();
          return;
        }
        var quick = e.target.closest('[data-tm-added-quick]');
        if (quick) {
          e.preventDefault();
          if (quick.disabled) return;
          quick.disabled = true;
          quick.textContent = 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [{ id: Number(quick.getAttribute('data-tm-added-quick')), quantity: 1 }] }),
          })
            .then(function (res) {
              if (!res.ok) throw new Error('add failed');
              return tmRefreshCart();
            })
            .then(function () {
              quick.textContent = '✓ Added';
            })
            .catch(function () {
              quick.disabled = false;
              quick.textContent = 'Try again';
            });
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && tmPanel && tmPanel.classList.contains('is-open')) tmClosePanel();
      });
      return tmPanel;
    }

    function tmRefreshCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (cart) {
          if (!cart) return null;
          tmUpdateHeaderCart(cart);
          if (tmPanel) {
            var sub = tmPanel.querySelector('[data-tm-added-subtotal]');
            var cnt = tmPanel.querySelector('[data-tm-added-count]');
            if (sub) sub.textContent = tmMoney(cart.total_price);
            if (cnt)
              cnt.textContent =
                'Cart subtotal (' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ')';
          }
          try {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('t4s:cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          } catch (e) {}
          return cart;
        })
        .catch(function () {
          return null;
        });
    }

    function tmOpenPanel(panel) {
      if (panel.classList.contains('is-open')) return;
      tmPanelLastFocus = document.activeElement;
      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      void panel.offsetWidth;
      panel.classList.add('is-open');
      document.documentElement.classList.add('tm-added-open');
      var dialog = panel.querySelector('.tm-added__panel');
      try {
        dialog.focus({ preventScroll: true });
      } catch (e) {}
    }

    /* Sequence: button turns green with a check right away -> cart count
       updates and the header / toolbar cart icon bounces -> panel slides in
       (~0.75s later, so the icon animation is seen before the panel covers it).
       With prefers-reduced-motion the panel opens immediately, no animation. */
    var tmOpenTimer = null;
    /* 2026-10-02 unified side cart: open the theme's side cart drawer in "just added" mode
       (assets/tm-added-panel.js). The product-page panel below stays as the fallback. */
    function tmAfterAdd(line) {
      tmAtcSuccess();
      tmShowGiftLink();
      if (window.TMAddedPanel && typeof window.TMAddedPanel.show === 'function') {
        try {
          try {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('t4s:cart:refresh', { bubbles: true }));
          } catch (e) {}
          window.TMAddedPanel.show(line, {
            title: tmShortTitle(line || {}),
            productId: line && line.product_id,
            fallback: function () {
              tmLegacyAfterAdd(line);
            },
          });
          return;
        } catch (e) {}
      }
      tmLegacyAfterAdd(line);
    }

    function tmLegacyAfterAdd(line) {
      var panel = tmEnsurePanel();
      panel.querySelector('[data-tm-added-body]').innerHTML = tmLineHtml(line) + tmPanelPairsHtml();
      var sub = panel.querySelector('[data-tm-added-subtotal]');
      if (sub) sub.textContent = '';
      clearTimeout(tmOpenTimer);
      var started = Date.now();
      var delay = tmReduceMotion ? 0 : 750;
      var opened = false;
      var openOnce = function () {
        if (opened) return;
        opened = true;
        clearTimeout(tmOpenTimer);
        tmOpenPanel(panel);
      };
      if (!delay) openOnce();
      /* Never wait more than 1.6s for /cart.js before showing the panel. */
      tmOpenTimer = setTimeout(openOnce, delay ? 1600 : 0);
      tmRefreshCart().then(function () {
        if (opened) return;
        var wait = Math.max(0, delay - (Date.now() - started));
        clearTimeout(tmOpenTimer);
        tmOpenTimer = setTimeout(openOnce, wait);
      });
    }

    api.afterAdd = tmAfterAdd;
    api.ready = true;
})();